import { Box } from '@mui/material';
import { func, object, oneOfType, string } from 'prop-types';
import React, { useCallback } from 'react';
import ChatInput from './ChatInput';

const fieldSx = {
  flexGrow: 1,
  maxHeight: '50vh',
  overflow: 'auto',
};

const ChatField = ({
  name,
  value,
  placeholder,
  onChange,
  onFormatStateChange,
  onLinkShortcut,
  onLinkEdit,
  onPaste,
  inputRef = () => {},
  suggestionsPortal,
  onSend,
}) => {
  const listenForEnter = useCallback(
    async e => {
      const code = e.keyCode ? e.keyCode : e.which;

      if (code === 13 && !e.shiftKey) {
        onSend(e);
      }
    },
    [onSend],
  );
  return (
    <Box sx={fieldSx}>
      <ChatInput
        name={name}
        value={value}
        placeholder={placeholder}
        onKeyPress={listenForEnter}
        onChange={onChange}
        onFormatStateChange={onFormatStateChange}
        onLinkShortcut={onLinkShortcut}
        onLinkEdit={onLinkEdit}
        onPaste={onPaste}
        inputRef={inputRef}
        suggestionsPortal={suggestionsPortal}
      />
    </Box>
  );
};

ChatField.propTypes = {
  placeholder: string.isRequired,
  name: string.isRequired,
  value: string.isRequired,
  onSend: func.isRequired,
  onChange: func.isRequired,
  onFormatStateChange: func,
  onLinkShortcut: func,
  onLinkEdit: func,
  onPaste: func.isRequired,
  inputRef: oneOfType([object, func]),
  suggestionsPortal: object.isRequired,
};

export default ChatField;
